
import { useNavigate } from "react-router-dom";
import { Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { CargandoMedio, MensajeAlertaDanger, ModalFormulario, TooltipAndIcon } from "../../components";
import { FormularioUnidadMedida } from "../components";
import { LayoutDesplegable, LayoutTabla } from "../../layouts";
import { iconos } from "../../../data";
import { useModalStore, useUnidadesMedidaStore } from "../../../stores";
import { useTodasUnidadesMedida } from "../../../hooks/cache/ui/useUnidadesMedida";
import { BuscadorXTermino } from "../../components/buscadores";




export const ListadoUnidadMedida = () => {


    const navigate = useNavigate();
    const { modalFormToggle } = useModalStore();
    const { data, isLoading, termino, chageTermino } = useTodasUnidadesMedida();
    const { activarUnidadMedida, setActivarUnidadMedida } = useUnidadesMedidaStore();



    const handleActualizarMedida = async(unidad) => {
        setActivarUnidadMedida(unidad);
        modalFormToggle(true);
    }



    const cerrarModal = () => {
        setActivarUnidadMedida(null);
        modalFormToggle(false)
    }



    const menu = [ 
        { title: 'Agregar Unidad', action:() => modalFormToggle(true), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];



    return (

        <LayoutDesplegable titulo="Listado Unidades de Medida" subtitulo='Información unidades de medida' menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de unidades de medida..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="unidad medida" playhol="nombre" />
                
                {( data?.length > 0)
                ?   <LayoutTabla>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'70%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'30%'}}>OPCIONES</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                        {data.map( ( uni ) => (
                            <TableRow key={ uni.id } >
                                <TableCell> { uni.nombre } </TableCell>
                                <TableCell >
                                    <Stack direction="row" spacing={1} justifyContent="center">
                                        <TooltipAndIcon
                                            titulo="Editar Unidad-Medida"
                                            icono="editar"
                                            color="white"
                                            onClick={ () => handleActualizarMedida(uni) }
                                        />  
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </LayoutTabla>
                
                :   <MensajeAlertaDanger titulo="No existen datos de unidad de medida" />
                }
                </>
            }


            <ModalFormulario titulo={`${(activarUnidadMedida) ? 'Editar' : 'Crear'} Unidad Medida`} valor={{}} onClose={cerrarModal}>
                <FormularioUnidadMedida  cerrarModal={cerrarModal} />
            </ModalFormulario>
        </LayoutDesplegable>
    )
}
